import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f13bd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "segments-container" }
const _hoisted_2 = ["aria-selected", "aria-controls", "id", "onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "underline" }, null, -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "opacity-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.segments, (segment, index) => {
      return (_openBlock(), _createElementBlock("div", {
        role: "tablist",
        class: "segment-wrapper",
        key: index
      }, [
        _createElementVNode("button", {
          type: "button",
          role: "tab",
          class: _normalizeClass(["segment", { 'is-current': index === $setup.selectedIndex }]),
          style: _normalizeStyle($setup.getSegmentStyle(index)),
          "aria-selected": index === $setup.selectedIndex,
          "aria-controls": `segment-panel-${index}`,
          id: `segment-tab-${index}`,
          onClick: ($event: any) => ($setup.onChangedSegmentIndex(index))
        }, _toDisplayString(segment), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_2)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", {
      class: "nav-underline",
      style: _normalizeStyle($setup.getUnderlineStyle())
    }, null, 4 /* STYLE */),
    _hoisted_3,
    ($props.shouldShowOpacity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("v-if", true)
  ]))
}